import Logger from '../util/Logger';
import { popinApi } from './api';

export const ideaApi = {

  getIdeas: (eventId) => {
    return Promise.resolve().then(() => {
      if (!eventId) {
        Logger.info('reject getIdeas()');
        throw Error('Must pass an eventId');
      } else {
        return popinApi.get(`/ideas/list?event_id=${eventId}`);
      }
    }).catch(error => {
      // This will be handled in the saga
      return { ideasError: error };
    });
  },

  updateIdea: (idea) => {
    return Promise.resolve().then(() => {
      if (!idea || !idea.id) {
        Logger.info('reject updateIdea()');
        throw Error('Must pass an idea');
      } else {
        return popinApi.post(`/ideas/edit`, idea);
      }
    }).catch(error => {
      // This will be handled in the saga
      return { ideasError: error };
    });
  },

  archive: (ideaId) => {
    return Promise.resolve().then(() => {
      if (!ideaId) {
        Logger.info('reject archive()');
        throw Error('Must pass an ideaId');
      } else {
        return popinApi.del(`/ideas/delete/${ideaId}`);
      }
    });
  }
};
